<template>
  <v-app class="app bg-color">
    <v-app-bar app color="primary" clipped-left dark>
      <v-app-bar-nav-icon @click="drawer = !drawer">
        <template>
          <v-icon>mdi-text</v-icon>
        </template>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="pl-1">CANAL+ API</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="user.balance_type === 'PREPAID' && user.role === 'ROLE_PARTNER'"
        outlined
        color="white"
        @click="refreshBalance()"
        :loading="loading.balance"
        class="mr-2"
      >
        <span class="text-body-2"
          ><span class="font-weight-bold mr-1"
            >{{ $t("commons.fields.balance.title") }}:</span
          >{{ $utils.numberformat(user.balance, lang) }}</span
        >
      </v-btn>
      <v-menu offset-y left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="40">
              <v-img
                :src="require('@/assets/img/user.png')"
                :alt="$auth.user().username"
              ></v-img>
            </v-avatar>
          </v-btn>
        </template>
        <v-list-item-title>
          <v-list class="py-1">
            <v-list-item>
              <v-list-item-avatar size="40">
                <img
                  :src="require('@/assets/img/user.png')"
                  :alt="user.username"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold grey--text text--darken-4 text-body-2">{{
                    fullname
                  }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ user.username }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :to="{ name: 'account' }">
              <v-list-item-title>
                <span class="text-body-2">
                  {{ $t("menu.account.title") }}
                </span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'logout' }">
              <v-list-item-title>
                <span class="text-body-2">{{ $t("menu.logout.title") }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list-item-title>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      class="navigation"
      :color="
        !$vuetify.breakpoint.mdAndDown ? 'rgba(255,255,255, 0)' : '#ffffff'
      "
      app
      clipped
      v-model="drawer"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar size="50">
            <v-img :src="require('@/assets/img/user.png')"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <span class="font-weight-bold grey--text text--darken-4 text-body-2">{{
                user.username
              }}</span>
            </v-list-item-title>
            <v-list-item-subtitle class="text-body-2 grey--text text--darken-2">{{ role }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list flat dense nav class="pt-4 menu">
        <v-list-item
          exact
          exact-active-class="primary--text"
          :to="{ name: 'home' }"
          class="mb-2"
        >
          <v-list-item-icon>
            <v-icon>mdi-credit-card-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              $t("menu.subscription")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          exact
          exact-active-class="primary--text"
          :to="{ name: 'distributor-transfer' }"
          class="mb-2"
        >
          <v-list-item-icon>
            <v-icon>mdi-transfer</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              $t("menu.distributor.transfer")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          exact
          exact-active-class="primary--text"
          :to="{ name: 'cga-manager' }"
          class="mb-2"
        >
          <v-list-item-icon>
            <v-icon>mdi-television</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              $t("menu.cga.manager.title")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          active-class="primary--text"
          :to="{ name: 'account' }"
          class="mb-2"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              $t("menu.account.title")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          active-class="primary--text"
          :to="{ name: 'user' }"
          class="mb-2"
          v-if="$auth.check(['ROLE_ADMIN'])"
        >
          <v-list-item-icon>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              $t("menu.user.title")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid class="pa-5">
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer>
      <v-spacer></v-spacer>
      <div class="font-weight-bold grey--text text--darken-1 text-body-2">
        &copy; CANAL+ API 2023
      </div>
    </v-footer>
  </v-app>
</template>


<script>
export default {
  created() {
    this.lang = this.$utils.setLocaleToBCP47(this.$i18n.locale);
  },
  data: () => ({
    drawer: true,
    lang: null,
    loading: {
      balance: false,
    },
  }),
  methods: {
    isRoute(routes) {
      const route_name = this.$route.name;
      return routes.includes(route_name);
    },
    async refreshBalance() {
      this.loading.balance = true;
      try {
        await this.$auth.fetch();
      } catch (error) {
        // empty
      }
      this.loading.balance = false;
    },
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    fullname() {
      const user = this.$auth.user();
      return `${user.profile.first_name} ${user.profile.last_name}`;
    },
    role() {
      return this.$t("users.fields.role." + this.$auth.user().role);
    },
  },
};
</script>